/**
 *
 */
export const mescUrl = {

    'LOCAL': 'http://localhost.gm.com/',
    'DEV': 'https://ctwr-dev.musea2.azure.ext.gm.com/',
    'QA': 'https://mesc-ui-ocf-qa.apps.pcfepgstg1mi.gm.com/',
    'TEST': 'https://mesc-ui-ocf-test.apps.pcfepgstg1mi.gm.com/',
    'PROD': 'https://mesc-ui.oc1i.gm.com/',

};
/**
 *
 */
export const mescServicesUrl = {
    //PCF
    LOCAL: 'http://localhost:2076/api/',
    TEST: 'https://mfg-gateway-test.gm.com/ctwr/api/',
    PROD: 'https://ctwr-api.oc1i.gm.com/api/',

    //OCF
    DEV: 'https://mesc-service-dev.musea2.azure.ext.gm.com/ctwr-service/api/',
    QA: 'https://mfg-gateway-qa.gm.com/ctwr/api/',


};

/**
 *
 */
export const mescModules = [
    <MescModuleView>{
        title: 'CTWR',
        subtitle: 'Casting Tooling Work Request',
        description: 'Create and manage Work Requests.',
        url: 'https://mesc-ui-ctwr-qa.cp-epg2i.gm.com/#/CTWR',
        route: '/CTWR',
        imageClass: 'image-ctwr'
    },
    <MescModuleView>{
        title: 'PHF',
        subtitle: 'Part Handling Forum',
        description: 'Manage and optimize part handling and storage.',
        url: 'https://mesc-ui-phf-qa.cp-epg2i.gm.com/#/PHF',
        route: '/PHF',
        imageClass: 'image-phf'
    },
]
/**
 *
 */
export class MescModuleView {
    title: string;
    subtitle: string;
    description: string;
    url: string;
    route: string;
    imageClass?: string;
}

